// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"957":"1932b9c84b6d0ca6","2111":"6177ee7860d75594","4747":"1932b9c84b6d0ca6","8831":"4ad7b01246de50ca"}[chunkId] + ".css";
};